import { extractYouTubeVideoId } from "../../../extractor/youtube-embed-extractor";

import { Roles } from "../../../../constants/roles";

type YouTubeEmbedRenderOptions = {
    maxWidth?: string;
    autoplay?: boolean;
};

function buildYouTubeEmbedNode(url: string, options: YouTubeEmbedRenderOptions = {}): HTMLElement | null {
    try {
        const videoId = extractYouTubeVideoId(url);
        if (!videoId) return null;

        const container = document.createElement("div");
        container.className = "sns-embed youtube-embed";
        container.setAttribute("data-role", Roles.SNS_EMBED);
        container.style.cssText = "margin-bottom: 16px; margin-top: 16px;";

        const wrapper = document.createElement("div");
        wrapper.style.cssText =
            "position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: " +
            (options.maxWidth || "100%") +
            ";";

        const iframe = document.createElement("iframe");
        const autoplayQuery = options.autoplay ? "?autoplay=1&playsinline=1&rel=0" : "?rel=0";
        iframe.src = `https://www.youtube.com/embed/${videoId}${autoplayQuery}`;
        iframe.style.cssText = "position: absolute; top: 0; left: 0; width: 100%; height: 100%;";
        iframe.frameBorder = "0";
        iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
        iframe.allowFullscreen = true;
        iframe.loading = "lazy";

        wrapper.appendChild(iframe);
        container.appendChild(wrapper);
        return container;
    } catch (e) {
        console.error("buildYouTubeEmbedNode failed", e);
        return null;
    }
}

export { buildYouTubeEmbedNode };
